import { render, staticRenderFns } from "./CreateFormula.vue?vue&type=template&id=0f08d706"
import script from "./CreateFormula.vue?vue&type=script&lang=js"
export * from "./CreateFormula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports